module.exports = __webpack_public_path__ + "img/telegram.d909d6e0.svg";